export const SEATS_VERSIONS_FEATURE_FLAG = 'SEATS_VERSIONS_FEATURE_FLAG';
export const STARTER_SUITE_GWP_JAN23 = 'STARTER_SUITE_GWP_JAN23';